export default "__VITE_ASSET__oauv35io__"